import logger from "@next/core-logger"
import {AnyAction, Dispatch} from "@reduxjs/toolkit"
import {ThunkAction} from "redux-thunk"
import isSalePage from "../../utils/isSalePage"
import type {State} from "../../models/State"
import {getCategorySegmentFromUrl} from "../../utils/getCategoryFromUrl"

export const SET_SALE = "SET_SALE"
type GetStateFn = () => State
interface SetSaleAction {
    type: typeof SET_SALE
    data: SaleDuckState
}

export type SaleDuckState = {
    isSalePage: boolean
    saleDisplayText: string | null
}
const initialState: SaleDuckState = {
    isSalePage: false,
    saleDisplayText: null,
}

const SetSaleAction = (data: SaleDuckState) => {
    return {
        type: SET_SALE,
        data,
    }
}

export const updateSaleThunk =
    (saleDisplayText?: string): ThunkAction<void, State, unknown, AnyAction> =>
    (dispatch: Dispatch, getState: GetStateFn) => {
        try {
            const {request} = getState()

            const categoryUrlSegment = getCategorySegmentFromUrl(request.url, request.siteUrl, request.type)
            if (!isSalePage(categoryUrlSegment)) {
                dispatch(SetSaleAction(initialState))
                return
            }

            dispatch(
                SetSaleAction({
                    isSalePage: true,
                    saleDisplayText: saleDisplayText ?? null,
                }),
            )
        } catch (error) {
            const err = error as Error
            logger.error(err)
            dispatch(SetSaleAction(initialState))
        }
    }

const reducer = (state: SaleDuckState = initialState, action: SetSaleAction): SaleDuckState => {
    switch (action.type) {
        case SET_SALE:
            return action.data
        default:
            return state
    }
}

export default reducer
